<div class="timeline-loading-overlay">
  <div class="loader-card">
    <app-logo class="brand"></app-logo>
    <div class="progress">
      <div class="bar"></div>
    </div>
    <div class="hint">Loading...</div>
  </div>
</div>
